export const resolveAvatarUrl = (url: string | undefined | null, fallback: string): string => {
  if (!url) return fallback
  const trimmed = url.trim()
  if (!trimmed) return fallback
  const isHttp = /^https?:\/\//i.test(trimmed)
  const isData = /^data:image\//i.test(trimmed)
  return isHttp || isData ? trimmed : fallback
}
